<iframe [width]="width" [height]="height" [src]="src" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>
</iframe>
